import {
  EStateCode,
  EStatusCode,
} from '../interfaces/api/phone-call.interface';

type DynCallType = {
  statuscode: EStatusCode;
  statecode: EStateCode;
};

export const getCallStatus = (
  callState: EStatusCode,
): DynCallType | Record<PropertyKey, never> => {
  switch (callState) {
    case EStatusCode.OPEN:
      return {
        statuscode: callState,
        statecode: EStateCode.OPEN,
      };

    case EStatusCode.MADE:
    case EStatusCode.RECEIVED:
      return {
        statuscode: callState,
        statecode: EStateCode.COMPLETED,
      };

    case EStatusCode.CANCELED:
      return {
        statuscode: callState,
        statecode: EStateCode.CANCELED,
      };
    default:
      return {};
  }
};
